import {getPath} from '@epic-core/common';
import React from 'react';
import {Redirect} from './Redirect';
import {ServerRoute} from './routes';

export const getAppRedirects = (): ServerRoute[] => {
    const path = getPath();

    return [
        {
            path: `${path}:locale/`,
            element: <Redirect to="/home" />
        },
        {
            path: `${path}:locale/bing-search`,
            element: <Redirect to="/search" />
        },
        {
            path: `${path}:locale/features`,
            element: <Redirect to="/services" />
        },
        {
            path: `${path}:locale/engine`,
            element: <Redirect url="https://www.unrealengine.com/" />
        },
        {
            path: `${path}:locale/branding`,
            element: <Redirect url="https://www.unrealengine.com/branding" />
        },
        {
            path: `${path}:locale/store`,
            element: <Redirect url="https://www.epicgames.com/store/about" />
        },
        {
            path: `${path}:locale/eula`,
            element: <Redirect url="https://dev.epicgames.com/portal/eula" />
        },
        {
            path: `${path}:locale/services/terms`,
            element: <Redirect url="https://dev.epicgames.com/portal/eula" />
        },
        {
            path: `${path}:locale/support`,
            element: <Redirect url="https://eoshelp.epicgames.com" />
        },
        {
            path: `${path}:locale/account`,
            element: <Redirect url="https://dev.epicgames.com/portal/eula" />
        }
    ];
};
